const STORE_LOCATOR = {
  TITLE: "NEED HELP ?",
  URL: "/contactus",
  CTA: "CONTACT US",
};
const NEWS_LETTER = {
  TITLE: "SUBSCRIBE NEWSLETTER",
  PLACEHOLDER: "Enter your email here",
  CTA: "DONE",
  SUCCESS: "Good Mooove! You've Just Signed Up For The Latest Updates",
  INVALID_EMAIL: "Please input a valid email",
};

const SOCIAL_MEDIA_LINKS = {
  TITLE: "CONNECT WITH US",
  LINKS: [
    {
      ICON: "icomoon-facebook",
      TITLE: "facebook",
      URL: "https://www.facebook.com/wildcraft/",
    },
    {
      ICON: "icomoon-instagram",
      TITLE: "instagram",
      URL: "https://www.instagram.com/wildcraftin/",
    },
    {
      ICON: "icomoon-twitter",
      TITLE: "twitter",
      URL: "https://twitter.com/wildcrafttweet/",
    },
    {
      ICON: "icomoon-linkedin",
      TITLE: "linked in",
      URL: "https://in.linkedin.com/company/wildcraft",
    },
  ],
};

const DELIVERY_OFFERS = [
  {
    TEXT: "7-day Returns",
    URL: "/customercare#RETURNS_AND_EXCHANGES",
    CLASSNAME: "nwc-grid-col-sm-4 nwc-grid-col-xs-6",
    ICON: "icomoon-rotate-left",
  },
  {
    TEXT: "COD available up to ₹2999",
    URL: "",
    CLASSNAME: "nwc-grid-col-sm-4 nwc-grid-col-xs-6",
    ICON: "icomoon-rupee",
  },
  {
    TEXT: "Free shipping for all orders",
    URL: "",
    CLASSNAME: "nwc-grid-col-sm-4 nwc-grid-col-xs-12",
    ICON: "icomoon-delivery",
  },
];

const PRIVACY_POLICY = {
  COPYRIGHT_TEXT: (() =>
    `© ${new Date().getFullYear()} Wildcraft. All Rights Reserved.`)(),
  COPYRIGHT_URL: "",
  POLICY: "Privacy Policy",
  POLICY_URL: "/privacypolicy",
  TNC: "Terms & Conditions",
  TNC_URL: "/termsconditions",
};

const TRADEMARK = {
  TEXT: "powered by",
  LOGO: "https://static.omuni.com/omuni_logo.png",
};

const FOOTER_LINKS = {
  EXCLUDED_TEXTS: ["*"],
};
const DEFAULT_FOOTER_DOCS = [];
const SPECIFIC_PAGES = {
  Style: [],
};
export default {
  FOOTER_LINKS,
  STORE_LOCATOR,
  NEWS_LETTER,
  SOCIAL_MEDIA_LINKS,
  DELIVERY_OFFERS,
  PRIVACY_POLICY,
  TRADEMARK,
  DEFAULT_FOOTER_DOCS,
  SPECIFIC_PAGES
};
